import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/views/index.vue'
import Home from '@/components/views/home.vue'
import About from '@/components/views/About.vue'
// 登录注册
import Login from '@/components/views/login/login.vue'
import Register from '@/components/views/login/register.vue'
import Findpassword from '@/components/views/login/findpassword.vue'
import Setpassword from '@/components/views/login/setpassword.vue'
import Evpi from '@/components/views/login/evpi.vue'
import Result from '@/components/views/login/result.vue'
// 商品
import Goods from '@/components/views/goods/goods.vue'
import GoodsDetails from '@/components/views/goods/goodsdetails.vue'
import Replenish from '@/components/views/goods/replenish.vue'
import Collection from '@/components/views/goods/collection.vue'
import Seen from '@/components/views/goods/seen.vue'
// 购物车
import ShoppingCart from '@/components/views/shoppingcart/shoppingcart.vue'
import OrderInfo from '@/components/views/shoppingcart/orderinfo.vue'
import Pay from '@/components/views/shoppingcart/pay.vue'
// 订单
import Order from '@/components/views/order/order.vue'
import OrderReturn from '@/components/views/order/orderreturn.vue'
import OrderDetails from '@/components/views/order/orderdetails.vue'
import Logistics from '@/components/views/order/logistics.vue'
import PayRecord from '@/components/views/order/payrecord.vue'
import ReturnGoods from '@/components/views/order/returngoods.vue'
import ReturnDetails from '@/components/views/order/returndetails.vue'
// 促销
import Promotion from '@/components/views/promotion/promotion.vue'
import FullReduceSend from '@/components/views/promotion/fullreducesend.vue'
// 优惠券
import Cpupon from '@/components/views/coupon/coupon.vue'
// 资金
import PayRecordCapital from '@/components/views/capital/payrecord.vue'
import DepositRecord from '@/components/views/capital/depositrecord.vue'
// 统计
import OrderGoodSummary from '@/components/views/statistics/ordergoodsummary.vue'
import OrderStatistics from '@/components/views/statistics/orderstatistics.vue'
import ClassifyStatistics from '@/components/views/statistics/classifystatistics.vue'
import BrandStatistics from '@/components/views/statistics/brandstatistics.vue'
// 消息通知
import Notice from '@/components/views/news/notice.vue'
import News from '@/components/views/news/news.vue'
import NewsDetails from '@/components/views/news/_news.vue'
import Message from '@/components/views/news/message.vue'
// 帮助中心
import Help from '@/components/views/help/help.vue'
import HelpDetails from '@/components/views/help/_help.vue'
import ContactService from '@/components/views/help/contactservice.vue'
// 会员中心
import Accounts from '@/components/views/member/accounts.vue'
import Address from '@/components/views/member/address.vue'
import MyCoupon from '@/components/views/member/mycoupon.vue'
// 测试页面
import Test from '@/components/views/test.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      meta: {
        requireAuth: true,
      },
      children: [
        {path: '/', name: '首页', component: Home, meta: {requireAuth: true}},
        {path: '/About', name: '关于', component: About, meta: {requireAuth: true}},
        {path: '/Goods/:type', name: '商品', component: Goods, meta: {requireAuth: true}},
        {path: '/GoodsDetails/:id', name: '商品详情', component: GoodsDetails, meta: {requireAuth: true}},
        {path: '/Replenish', name: '最近购买的商品', component: Replenish, meta: {requireAuth: true}},
        {path: '/Collection', name: '收藏的商品', component: Collection, meta: {requireAuth: true}},
        {path: '/Seen', name: '看过的商品', component: Seen, meta: {requireAuth: true}},
        {path: '/ShoppingCart', name: '购物车', component: ShoppingCart, meta: {requireAuth: true}},
        {path: '/OrderInfo/:ggid', name: '填写订单', component: OrderInfo, meta: {requireAuth: true}},
        {path: '/Pay/:type/:id', name: '支付', component: Pay, meta: {requireAuth: true}}, // type 0 下单 1 充值  id 订单id 充值为空
        {path: '/Order', name: '订货单', component: Order, meta: {requireAuth: true}},
        {path: '/OrderReturn', name: '退货单', component: OrderReturn, meta: {requireAuth: true}},
        {path: '/OrderDetails/:id', name: '订货详情', component: OrderDetails, meta: {requireAuth: true}},
        {path: '/Logistics/:id', name: '出库/发货/物流', component: Logistics, meta: {requireAuth: true}},
        {path: '/PayRecord/:id', name: '付款记录', component: PayRecord, meta: {requireAuth: true}},
        {path: '/ReturnGoods/:id', name: '申请退货', component: ReturnGoods, meta: {requireAuth: true}},
        {path: '/ReturnDetails/:id', name: '退货单订单详情', component: ReturnDetails, meta: {requireAuth: true}},
        {path: '/Promotion', name: '商品促销', component: Promotion, meta: {requireAuth: true}},
        {path: '/FullReduceSend', name: '满减满送', component: FullReduceSend, meta: {requireAuth: true}},
        {path: '/Cpupon', name: '优惠券', component: Cpupon, meta: {requireAuth: true}},
        {path: '/PayRecordCapital', name: '支付记录', component: PayRecordCapital, meta: {requireAuth: true}},
        {path: '/DepositRecord', name: '预存款收支明细', component: DepositRecord, meta: {requireAuth: true}},
        {path: '/OrderGoodSummary', name: '订货汇总', component: OrderGoodSummary, meta: {requireAuth: true}},
        {path: '/OrderStatistics', name: '订单统计', component: OrderStatistics, meta: {requireAuth: true}},
        {path: '/ClassifyStatistics', name: '分类统计', component: ClassifyStatistics, meta: {requireAuth: true}},
        {path: '/BrandStatistics', name: '品牌统计', component: BrandStatistics, meta: {requireAuth: true}},
        {path: '/Notice', name: '消息通知', component: Notice, meta: {requireAuth: true}},
        {path: '/News', name: '公司通知公告', component: News, meta: {requireAuth: true}},
        {path: '/News/:id', name: '公司通知公告详情', component: NewsDetails, meta: {requireAuth: true}},
        {path: '/Message', name: '留言咨询', component: Message, meta: {requireAuth: true}},
        {path: '/Help', name: '帮助中心', component: Help, meta: {requireAuth: true}},
        {path: '/Help/:id', name: '帮助中心详情', component: HelpDetails, meta: {requireAuth: true}},
        {path: '/ContactService', name: '联系客服', component: ContactService, meta: {requireAuth: true}},
        {path: '/Accounts', name: '我的账号', component: Accounts, meta: {requireAuth: true}},
        {path: '/Address', name: '地址管理', component: Address, meta: {requireAuth: true}},
        {path: '/MyCoupon', name: '我的优惠券', component: MyCoupon, meta: {requireAuth: true}},
        // {path: '/newslist/:id', name: 'newsListid', component: newsListid}
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {title: '登录'},
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import(/* webpackChunkName: "Register" */ '@/components/views/login/register.vue'),
      meta: {title: '注册'},
    },
    {
      path: '/findpassword',
      name: 'Findpassword',
      component: () => import(/* webpackChunkName: "Findpassword" */ '@/components/views/login/findpassword.vue'),
      meta: {title: '找回密码'},
    },
    {
      path: '/setpassword/:phone',
      name: 'Setpassword',
      component: () => import(/* webpackChunkName: "Setpassword" */ '@/components/views/login/setpassword.vue'),
      meta: {title: '设置密码'},
    },
    {
      path: '/evpi/:phone',
      name: 'Evpi',
      component: () => import(/* webpackChunkName: "Evpi" */ '@/components/views/login/evpi.vue'),
      meta: {title: '完善信息'},
    },
    {
      path: '/result/:uid',
      name: 'Result',
      component: () => import(/* webpackChunkName: "Result" */ '@/components/views/login/result.vue'),
      meta: {title: '注册审核'},
    },
    {
      path: '/test',
      name: 'Test',
      component: () => import(/* webpackChunkName: "Test" */ '@/components/views/test.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js